module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3AWL0i/media/FC-9781528906494.jpg?1684870885412",
      "alt": "This image is the cover for the book Secret Island"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Secret Island\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Christopher and David are two lecturers who have come to Egypt to visit the magnificent pyramids. But awaiting them are not the mysteries of Egypt but of a land altogether unknown. Beyond a shroud of mist and raging seas, guarded by ferocious creatures, Atlantis is as mercurial as it is eerily familiar. Its people are proud guardians of all life on earth, from the dinosaurs they have given refuge to, to the eagles they revere."), _c('br'), _vm._v("This story tells of a race of people whose aim is to replenish the world with their stewardship. Chris and David are thrust into their enigmatic world with Amon, who has been separated from his homeland for years, and the first thing they have to face is a tribe of cannibals, intent on their next meal…")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Christopher Hayes-Brown\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("An accountant, always willing to support/help others, keen in wildlife conservation, helps to fight cancer, loves gardening and growing exotic plants, including orchids, has various pets, loves writing, dancing, Lau Gar Kung Fu, ancient history, various music and entomology.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0